import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { navigationHistory } from '../utils/navigationHistory';

export const useNavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track every route change
    navigationHistory.addPath(location.pathname);
  }, [location.pathname]);
};